export const onlyNums = (e) => {
  const allowedKeys = [
    "Backspace",
    "ArrowLeft",
    "ArrowRight",
    "Delete",
    "Tab",
    "Enter",
    "Escape",
    "Control",
    "Meta", // For macOS Command key
    "Shift",
    "Alt",
  ];

  if (e.ctrlKey || e.metaKey) {
    return;
  }

  const isNumberOrSymbol = /\d|\,|\./.test(e.key);

  if (!isNumberOrSymbol && !allowedKeys.includes(e.key)) {
    e.preventDefault();
  }
};
